/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React, { useState, useEffect } from "react";
import { useGlobal } from "../../../contexts/globalContext";
import HotelCard from "./HotelCard";
import * as S from "./styles";

const HotelList = ({ filters, searchState, stays, loading, buscaAtual }) => {
  const [staysFiltered, setStaysFiltered] = useState([]);
  const { setLoading } = useGlobal();

  useEffect(() => {
    setLoading(loading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  const filterByHotelName = (stays) => {
    return filters?.hotelName
      ? stays?.filter((s) =>
          s.basicPropertyInfo.hotelRef.hotelName
            ?.toLowerCase()
            .includes(filters.hotelName.toLowerCase())
        )
      : stays;
  };

  const filterByStars = (stays) => {
    return filters?.stars > 0
      ? stays?.filter(
          (s) => s.basicPropertyInfo?.award?.rating >= filters.stars
        )
      : stays;
  };

  const filterByDailyPrice = (stays) => {
    return filters?.dailyPrice
      ? stays?.filter(
          (s) =>
            s.price?.amountAfterTax >= filters?.dailyPrice[0] &&
            s.price?.amountAfterTax <= filters?.dailyPrice[1]
        )
      : stays;
  };

  const returnArrayOfValuesFilteredTrue = (field) => {
    return stays?.filter((stay) => {
      const matchStars =
        !filters?.stars ||
        stay.basicPropertyInfo?.award?.rating >= filters.stars;
      const matchMeals = stay.roomStays.roomTypes.find((roomType) =>
        roomType.roomRates.find(
          (roomRate) => roomRate.ratePlans?.mealsIncluded?.[field] === true
        )
      );
      return matchStars && matchMeals;
    });
  };

  const returnArrayOfValuesFilteredFalse = (field) => {
    return stays?.filter((stay) => {
      const matchStars =
        !filters?.stars ||
        stay.basicPropertyInfo?.award?.rating >= filters.stars;
      const matchMeals = stay.roomStays.roomTypes.find((roomType) =>
        roomType.roomRates.find(
          (roomRate) => roomRate.ratePlans?.mealsIncluded?.[field] === false
        )
      );
      return matchStars && matchMeals;
    });
  };

  const mealsIncludedFilterBreakfast = (stays) => {
    return filters?.breakfast
      ? returnArrayOfValuesFilteredTrue("breakfast")
      : stays;
  };

  const mealsIncludedFilterLunch = (stays) => {
    return filters?.lunch ? returnArrayOfValuesFilteredTrue("lunch") : stays;
  };

  const mealsIncludedFilterDinner = (stays) => {
    return filters?.dinner ? returnArrayOfValuesFilteredTrue("dinner") : stays;
  };

  const noBreakfast = (stays) => {
    return filters?.noBreakfast
      ? returnArrayOfValuesFilteredFalse("breakfast")
      : stays;
  };

  const mealsIncludedFilterAllInclusive = (stays) => {
    return filters?.allInclusive
      ? returnArrayOfValuesFilteredTrue("allInclusive")
      : stays;
  };

  const normalizeMealPlan = (name) =>
    name?.trim().toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ') ?? '';

  const filterByMealPlan = (stays) => {
    if (!filters?.mealPlans || filters.mealPlans.length === 0) return stays;
    const normalizedSelected = filters.mealPlans.map(normalizeMealPlan);
    return stays?.filter((stay) =>
      stay.roomStays.roomTypes.some((rt) =>
        rt.roomRates.some((rr) => {
          const mp =
            rr.mealPlan || rr.ratePlans?.mealPlanInfo?.mealPlanDescription;
          return normalizedSelected.includes(normalizeMealPlan(mp));
        })
      )
    );
  };

  useEffect(() => {
    setStaysFiltered(stays);
  }, [stays]);

  useEffect(() => {
    setStaysFiltered(
      filterByDailyPrice(
        filterByMealPlan(
          noBreakfast(
            mealsIncludedFilterLunch(
              mealsIncludedFilterDinner(
                mealsIncludedFilterAllInclusive(
                  mealsIncludedFilterBreakfast(
                    filterByStars(filterByHotelName(stays))
                  )
                )
              )
            )
          )
        )
      )
    );
  }, [filters]);

  return loading ? null : (
    <div>
      <S.Wrapper>
        <Grid container>
          <Grid item xs={12} md={12} lg={10}>
            <Grid container>
              {staysFiltered &&
                staysFiltered.length > 0 &&
                staysFiltered
                  .sort(
                    (a, b) => a.price?.amountAfterTax - b.price?.amountAfterTax
                  )
                  .map((hotel, index) => (
                    <Grid item xs={12} key={index}>
                      <S.HotelCardWrapper
                        style={{
                          animationDelay: `${index * 0.1}s`
                        }}
                      >
                        <HotelCard
                          hotel={hotel}
                          searchState={searchState}
                          buscaAtual={buscaAtual}
                        // hotel={{
                        //   pictures: [hotel.basicPropertyInfo.imageURL],
                        //   name: `${hotel.basicPropertyInfo.hotelRef.hotelName}`,
                        //   stars: hotel.basicPropertyInfo?.award?.rating,
                        //   location: hotel.basicPropertyInfo.address.addressLine,
                        //   centerDistance: 0.46,
                        //   price: hotel.price.amountBeforeTax,
                        //   nights:
                        //     (new Date(hotel.price.end) -
                        //       new Date(hotel.price.start)) /
                        //     (1000 * 3600 * 24),
                        //   before: hotel.price?.amountAfterTax,
                        //   rate: 7.9,
                        //   rateLevel: 'Bom',
                        //   reviews: 120,
                        //   code: hotel.basicPropertyInfo.hotelRef.hotelCode,
                        //   rooms: hotel.roomStays.roomTypes,
                        //   hotel,
                        // }}
                        />
                      </S.HotelCardWrapper>
                    </Grid>
                  ))}
            </Grid>
          </Grid>
        </Grid>
      </S.Wrapper>
    </div>
  );
};

export default HotelList;
